export default __webpack_public_path__ + "static/media/international.de43cb69.jpg";